"use client"

import { useSelector } from "react-redux"
import { ARTIST } from "@/data"

type Artist = (typeof ARTIST)[0]

function formatDate(dateStr?: string) {
  if (!dateStr) return "Sin fecha"
  return new Date(dateStr).toLocaleString("es-ES", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export default function ConcertsCard() {
  const trackData = useSelector((s: any) => s.trackData)

  const playlistIndex = trackData?.trackKey?.[0] ?? 0

  const artist: Artist | undefined = ARTIST.find(
    (a) => Number(a.id) === Number(playlistIndex)
  )

  if (!artist) return null

  return (
    <div className="w-full rounded-2xl bg-black/50 border border-white/10 px-4 py-3 backdrop-blur-xl">
      
      <p className="text-xs uppercase text-white/50 mb-3">
        Próximos conciertos
      </p>

      <div className="flex flex-col gap-3">

        {/* EVENTO PRINCIPAL */}
        <div className="flex gap-3 items-center">
          <img
            src={artist.clubImg || artist.imgUrl}
            className="w-12 h-12 rounded-xl object-cover"
            alt="club"
          />

          <div className="min-w-0">
            <p className="text-sm font-medium text-white truncate">
              {artist.club || "Evento privado"}
            </p>

            <p className="text-xs text-white/60">
              {formatDate(artist.clubtime)}
            </p>

            <p className="text-[11px] text-white/40 truncate">
              {artist.clubmapa}
            </p>
          </div>
        </div>

        {/* FINAL */}
        <div className="flex items-center justify-between text-xs text-white/40 pt-2 border-t border-white/10">
          <span>Fin: {formatDate(artist.endtime)}</span>
          <span className="text-white/60">Live radio</span>
        </div>

      </div>
    </div>
  )
}